import React    from 'react';
import Polite   from '../../../global/globalPrivacy';
import * as GV  from '../../../global/globalVariables';

function Privacy() {
    
    return (
        <>
        <Polite name={GV.APP_EXPENSES_AI}></Polite>
        </>
    )
}

export default Privacy;